import MasterService from './MasterService';


export const PointService = {
    ...MasterService,

    updatePoint(body){ 
        return this.post("pointConfig/updatePoint",body)
    },
    savePoint(body){ 
        return this.post("pointConfig/savePointConfig",body)
    },
    getPointAll(body){ 
        return this.post("pointConfig/getPointAll",body)
    },
    updateScore(body){ 
        return this.post("scoreConfig/updateScore",body)
    },
    saveScore(body){ 
        return this.post("scoreConfig/saveScoreConfig",body)
    },
    getScoreAll(body){ 
        return this.post("scoreConfig/getScoreAll",body)
    },
    deleteFinancierDetails(body) {
        return this.post("scoreConfig/removeScoreDetail",body)
    },
    saveAgentConfig(body){ 
        return this.post("pointConfig/saveAgentConfig",body)
    },
    getAllAgentPoints(body){ 
        return this.post("pointConfig/getAllAgentPoints",body)
    },
    updateAgentConfig(body){
        return this.post("pointConfig/updateAgentConfig",body)
    },
    removeAgentPointFinancier(body){
        return this.post("pointConfig/removeAgentPoint",body)
    } 
}